import { atom } from "recoil";

export const PopupAtom = atom({
    key: 'PopupState',
    default: {
        ModalName:'PopupBase', 
        Page:<></>, 
        isHide:false, 
        isCancel:false, 
        Width:0, 
        Height:0, 
        Title: ""},
});
